/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
const {connectHierarchicalMenu, connectRefinementList} = instantsearch.connectors;
const {relevantSort, infiniteHits: hits, queryRuleCustomData} = instantsearch.widgets;
const {connectRelevantSort} = instantsearch.connectors;
const {connectSortBy} = instantsearch.connectors;

let isUserInteract = false
const facetDropdownHolder = {}

if (!customElements.get('facet-dropdown')) {
  customElements.define('facet-dropdown', class FacetDropdown extends HTMLElement {
    constructor(element) {
      super()
      this.querySelectorAll(':scope > .refine-label .expander').forEach((item) => {
        item.addEventListener('click', (e) => {
          e.stopPropagation()
          e.stopImmediatePropagation()
          isUserInteract = true

          this.querySelector('.refine-list').classList.toggle('hidden')

          const expanded = !this.querySelector('.refine-list').classList.contains('hidden')
          facetDropdownHolder[this.getAttribute("data-value")] = expanded

          this.querySelector('.refine-label .refine-expaned').style.display = expanded ? 'block' : 'none'
          this.querySelector('.refine-label .refine-unexpaned').style.display = !expanded ? 'block' : 'none'
        })
      })
    }
  })
}

(function (algolia) {
  'use strict';

  window.saveAlgoliaTracking = (data) => {
    algolia.saveForConversionTracking(data)
  }

  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  // var hits = algolia.externals.widgets.infiniteHits;
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var connectCurrentRefinements = algolia.externals.connectors.connectCurrentRefinements;

  var collectionPageEnabled = algolia.is_collection_results_page && algolia.config.instant_search_enabled_on_collection;

  if (!algolia.full_results && !algolia.is_collection_results_page) {
    /**
     * If we aren't on the search page and neither on a collection page,
     * then there's no need to proceed
     */
    return;
  } else if (algolia.full_results) {
    /**
     * If we are on the search page and instant search isn't enabled,
     * then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled) {
      return;
    }
  } else if (algolia.is_collection_results_page) {
    /**
     * If we are on a collection page and instant search on collection isn't
     * enabled, then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled_on_collection) {
      return;
    }
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];

  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  var collectionHandle = null;

  if (collectionPageEnabled) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    collectionHandle = Boolean(matches) && matches.length === 2 ? matches[1] : null;

    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = collectionHandle ? 'collections:"' + collectionHandle + '"' : null;
    } else {
      collectionFacetFilter = 'collections:"' + collectionHandle + '"';
    }

    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);

    collectionRulesContextValue = algolia.config.collection_id_query_rules ? algolia.current_collection_id : collectionHandle;


  }

  // Filters for stock policy
  var filter_tag_oos = 'NOT tags:algolia30days';
  if (filter_tag_oos) {
    searchFilters.push(filter_tag_oos);
  }
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var results_selector = collectionPageEnabled ? algolia.config.collection_css_selector : algolia.config.results_selector;

  var activeSortOrders = collectionPageEnabled && algolia.collectionSortOrders ? algolia.collectionSortOrders : algolia.sortOrders;

  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function (k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /**
   * List of URL params which are "allowed" by InstantSearch.
   * These parameters won't be overwritten when the search state is written
   * to the URL.
   */
  var ALLOWED_FOREIGN_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function (uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function (routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function (acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  let isFirstPage = true
  const indexName = algolia.config.index_prefix + 'products'
  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),

    facets: {
      hidden: collectionPageEnabled && algolia.collectionHiddenFacets ? algolia.collectionHiddenFacets : algolia.hiddenFacets,
      shown: collectionPageEnabled && algolia.collectionShownFacets ? algolia.collectionShownFacets : algolia.shownFacets,
      list: collectionPageEnabled && algolia.collectionFacets ? algolia.collectionFacets : algolia.facets,
      widgets: collectionPageEnabled && algolia.collectionFacetsWidgets ? algolia.collectionFacetsWidgets : algolia.facetsWidgets,
    },
    hitsPerPage: collectionPageEnabled && algolia.config.collections_full_results_hits_per_page ? algolia.config.collections_full_results_hits_per_page : algolia.config.products_full_results_hits_per_page,
    search: instantsearch({
      searchClient: algoliasearch(algolia.config.app_id, algolia.config.search_api_key),
      insights: algolia.config.analytics_enabled,
      indexName: algolia.config.index_prefix + 'products',
      routing: {
        stateMapping: {
          stateToRoute(uiState) {
            const {configure, ...trackedUiState} = uiState[indexName];
            if (hasInitHierarchy && window.cachedRefinement) {
              trackedUiState.refinementList = {...window.cachedRefinement}
              window.cachedRefinement = null
            }

            if (trackedUiState.query) {
              trackedUiState.q = trackedUiState.query
            }
            delete trackedUiState.query

            return Object.assign({}, foreignRouteState, trackedUiState);
            // return trackedUiState
          }, routeToState(routeState = {}) {
            const {configure, ...trackedUiState} = routeState;

            if (!foreignRouteState) {
              foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function (acc, key) {
                acc[key] = routeState[key];
                return acc;
              }, {});
            }

            if (trackedUiState.refinementList !== undefined && !hasInitHierarchy) {
              window.cachedRefinement = {...trackedUiState.refinementList}
              trackedUiState.refinementList = {}
            }
            if (trackedUiState.q) {
              trackedUiState['query'] = trackedUiState.q
            }

            return {
              [indexName]: trackedUiState,
            };
          },
        }, // stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
      },
      searchFunction: function (searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }
        searchFunctionHelper.setQueryParameter('facetingAfterDistinct', false);

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter('filters', searchFilters.join(' AND '));
        }

        if (page === 0 && !isFirstPage) {
          window.scrollTo({
            top: 0
          })
        }

        isFirstPage = false

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        if (collectionPageEnabled) {
          // Collection page merchandising:
          // If we are on a collection page, `collectionRulesContextValue` is defined
          if (collectionRulesContextValue) {
            searchFunctionHelper.setQueryParameter('ruleContexts', [collectionRulesContextValue.toString(),]);
          } else {
            searchFunctionHelper.setQueryParameter('ruleContexts', []);
          }
        }
        console.log('set facet filters', searchFunctionHelper);
        // searchFunctionHelper.setQueryParameter('facetFilters', [['named_tags.lvl1:Clothing > Outerwear']]);
        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders,
    sortFacetValuesBy: 'alpha'
  };

  instant.search.client.addAlgoliaAgent('Shopify Integration');
  algolia.instantsearch = instant;


  function readjust() {
    var width = instant.$results.offsetWidth;

    var suffix = 'lg';
    if (width < 400) suffix = 'xs'; else if (width < 800) suffix = 'sm'; else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }


  //Link CSS and set up CSS variables
  const cssFile = document.getElementById('template_algolia_instant_search.css');
  document.documentElement.style.setProperty(`--main-color`, `${algolia.config.colors.main}`);
  document.documentElement.style.setProperty(`--secondary-color`, `${algolia.config.colors.secondary}`);
  document.documentElement.style.setProperty(`--highlight-bg-color`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  algolia.appendStyle(cssFile.text);

  if (collectionPageEnabled) {
    if (document.querySelectorAll(algolia.config.collection_css_selector).length === 0) {
      throw new Error('Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector');
    }
  } else if (document.querySelectorAll(algolia.config.results_selector).length === 0) {
    throw new Error('Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector');
  }

  // Instantiating the main page
  instant.$results = document.querySelector(instant.selector);
  instant.$results.innerHTML = '';
  algolia.render(algolia.instantSearchMainTemplate, instant.$results, {
    facets: instant.facets.list, multipleSortOrders: activeSortOrders.length > 1, query: instant.query,
  });

  readjust();

  window.addEventListener('resize', function () {
    readjust();
  });


  // Create the render function
  var createDataAttributesCategories = function (refinement) {
    return Object.keys(refinement)
      .map(function (key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItemCategories = function (item) {
    var facet = instant.facets.list.find(function (f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function (refinement) {

        return ('<li class="ais-current-refined-values--item">' + '  <a ' + createDataAttributesCategories(refinement) + '    class="ais-current-refined-values--link">' + '    <div class="categories_label">' + '      <div class="ais-current-refined-values--label">' + '      </div> ' + refinement.label + '    </div>' + '  </a>' + '</li>');
      })
      .join('');
  };

  var renderCurrentRefinementsCategories = function (renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;
    var filteredData = items.filter(item => item.attribute === "named_tags.lvl0");
    widgetParams.container.innerHTML = '<div class="ais-root ais-current-refined-values ais-facet categories_selected">' + '  <ul class="ais-current-refined-values--list">' + filteredData.map(renderListItemCategories).join('') + '  </ul>' + '</div>';

    Array.prototype.slice
      .call(widgetParams.container.querySelectorAll('.ais-current-refined-values--link'))
      .forEach(function (element) {
        element.addEventListener('click', function (event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function (acc, key) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
            return algolia.assign({}, acc, itemData);
          }, {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinementsCategories = connectCurrentRefinements(renderCurrentRefinementsCategories);

  const renderList = ({items, createURL}) => `
  <div class="ais-RefinementList ais-facet custom_hierarquical">
    <ul class="ais-RefinementList-list">
      ${items
    .map(item => `
            <li class="ais-RefinementList-item ais-facet--item">
              <a
                href=""
                class="categories_items ${item.data ? 'data_children' : ''} ${item.isRefined ? 'renifed_hierarquical' : ''}"
                data-value="${item.value}"
                style="font-weight: ${item.isRefined ? '' : ''}"
              >
                ${item.label} 
                <span class="ais-RefinementList-count ais-facet--count-distinct">  ${item.count} </span>
              </a>
             
              ${item.data ? renderList({items: item.data, createURL}) : ''}
            </li>
          `)
    .join('')}
    </ul>
  </div>
   
  `;

  const renderHierarchicalMenu = (renderOptions, isFirstRender) => {
    const {
      items, //isShowingMore,
      refine, toggleShowMore, createURL, widgetParams,
    } = renderOptions;

    if (isFirstRender) {
      const list = document.createElement('div');
      const button = document.createElement('button');

      const selectedPrice = document.createElement('li');
      selectedPrice.setAttribute('class', 'ais-RefinementList-item ais-facet--item ais-RefinementList-item--selected price-selected-hidden');
      selectedPrice.innerHTML = `
      <div>
        <label class="ais-RefinementList-label ais-facet--label options_size"> 14 </label>
      </div>
      `

      button.addEventListener('click', () => {
        toggleShowMore();
      });
      widgetParams.container.appendChild(list);
      //widgetParams.container.appendChild(selectedPrice);

      // widgetParams.container.appendChild(button);
    }

    const children = renderList({items, createURL});


    widgetParams.container.querySelector('div').innerHTML = children;
    // widgetParams.container.querySelector('button').textContent = isShowingMore
    //   ? 'Show less'
    //   : 'Show more';

    [...widgetParams.container.querySelectorAll('a')].forEach(element => {
      element.addEventListener('click', event => {
        event.preventDefault();
        refine(event.target.dataset.value);
      });
    });
  };


  // Create the custom widget
  const customHierarchicalMenu = connectHierarchicalMenu(renderHierarchicalMenu);

  function getPlatform() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 'mobile' : 'desktop'
  }

  let hasInitHierarchy = false
  let hasSetupClearEvent = false

  const levelRefined = {}

  let refinedList = []

  function setupClearRefinement() {
    document.querySelector('.ais-ClearRefinements-button').addEventListener('click', () => {
      isUserInteract = true
      refinedList = refinedList.map(item => ({...item, isRefined: false}))
      document.querySelectorAll('.refine-item.refined').forEach(item => item.classList.remove('refined'))
      buildCurrentRefine()
    })
  }

  if (!customElements.get('current-refined')) {
    customElements.define('current-refined', class CurrentRefined extends HTMLElement {
      constructor() {
        super();

        this.addEventListener('click', (event) => {
          isUserInteract = true
          const dataset = event.target.dataset
          levelRefined[dataset.key](dataset.value)
          const index = refinedList.findIndex(item => item.value === dataset.value)
          refinedList[index].isRefined = false
          document.querySelector(`.refine-target[data-value="${dataset.value}"]`)?.closest('.refine-item').classList.remove('refined')
          buildCurrentRefine()
        })
      }
    })
  }

  function processHierarchLevel(pointer, items, key, level = 0) {
    for (const item of pointer.items) {
      if (!item.items) {
        item.items = []
        for (const sub of items) {
          const parts = sub.value.split('>').map(item => item.trim())
          const lastPart = parts[parts.length - 1]
          const currentPart = parts.slice(0, -1).join(' > ')

          if (item.value === currentPart) {
            item.items.push({
              ...sub,
              refine: key,
              isRefined: refinedList.find(item => item.value === sub.value)?.isRefined ?? false,
              label: lastPart
            })
          }
        }

        item.items = sortArrayByFirstLetter(item.items)
      } else {
        processHierarchLevel(item, items, key, level + 1)
      }
    }
  }

  function sortArrayByFirstLetter(array) {
    return array.sort((a, b) => {
      const nameA = a.label[0].toUpperCase(); // 忽略大小写
      const nameB = b.label[0].toUpperCase(); // 忽略大小写
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    })
  }

  function processHierarchyData(jsonData) {
    let hierarchy = {};
    let pointer = null

    let level = 0
    for (let key in jsonData) {
      const isLevelFacet = /lvl[0-9]$/.test(key)
      if (!isLevelFacet) {
        continue
      }

      if (level === 0) {
        hierarchy[key] = jsonData[key];
        pointer = hierarchy[key];
        pointer.items = sortArrayByFirstLetter(pointer.items.map(item => ({
          ...item, isRefined: refinedList.find(sub => item.value === sub.value)?.isRefined ?? false, refine: key,
        })));
      } else {
        const items = jsonData[key].items
        processHierarchLevel(pointer, items, key)
      }
      level += 1
    }

    return hierarchy;
  }

  function buildCurrentRefine() {
    let html = ''
    refinedList.filter(item => item.isRefined).forEach(item => {
      html += `
        <current-refined class="ais-current-refined-item" data-value="${item.value}" data-key="${item.key}">${item.label}</current-refined>
      `
    })
    document.querySelector('#current-refined').innerHTML = html
  }


  function buildHtml(data, level = 0) {
    return data.items.map(facet => {
      if (!facet.items || (facet.items && facet.items.length === 0 && level > 0)) return `<li class="refine-item ${facet.isRefined ? 'refined' : ''}">
                  <label class="refine-label" >
                    <span class="refine-target" data-key="${facet.refine}" data-value="${facet.value}">
                     <span class="refine-dot"> </span>
                      ${facet.label}
                    </span>
                  </label>
                </li>`


      return `
        <facet-dropdown data-value="${facet.value}" style="display: block" class="refine-item ${facet.isRefined ? 'refined' : ''}">
            <label for="${facet.label}"
                   class="refine-label" >
                   <span class="refine-target" data-key="${facet.refine}" data-value="${facet.value}" >
                     <span class="refine-dot" ></span>
                     ${facet.label}
                   </span>
                   
                   <span class="refine-expaned expander" style="display: ${facet.items.length && facetDropdownHolder[facet.value] ? 'block' : 'none'}">
                     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128Z"></path></svg>
                   </span>
                   <span class="refine-unexpaned expander" style="display: ${facet.items.length && !facetDropdownHolder[facet.value] ? 'block' : 'none'}">
                     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"></path></svg>
                   </span>
           </label>
            <ul class="refine-list ${facetDropdownHolder[facet.value] ? '' : 'hidden'}">
            ${!facet.items || (facet.items && facet.items.length === 0 && level > 0) ? `<li class="refine-item ${facet.isRefined ? 'refined' : ''}" >
                  <label class="refine-label" >
                    <span class="reine-target" data-key="${facet.refine}" data-value="${facet.value}">
                     <span class="refine-dot" ></span>
                      ${facet.label}
                    </span>
                  </label>
                </li>` : buildHtml(facet, level + 1)}
            </ul>
        </facet-dropdown>`
    }).join('\n')
  }


  let refinementList = {}

  function renderRefineListDOM(renderOptions) {
    const {items, canRefine, refine} = renderOptions;
    const container = renderOptions.widgetParams.container;

    if (refinedList.length > 0) {
      const levelRefinement = processHierarchyData(refinementList)
      let index = 0
      for (const key in levelRefinement) {
        if (index === 0 && levelRefinement[key].items.length === 1) {
          levelRefinement[key] = levelRefinement[key].items[0]
        }
        index++
      }

      // for (const key in levelRefinement) {
      //   levelRefinement[key].items = levelRefinement[key].items.filter(item => item.items.length > 0)
      // }
      container.innerHTML = buildHtml(levelRefinement['named_tags.lvl0'])
      container.querySelectorAll('.refine-target[data-value]').forEach(element => {
        element.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          isUserInteract = true

          const dataset = event.currentTarget.dataset
          levelRefined[dataset.key](dataset.value)

          const refineItem = event.target.closest('.refine-item')
          const index = refinedList.findIndex(item => item.value === dataset.value)
          if (refineItem.classList.contains('refined')) {
            refineItem.classList.remove('refined')
            refinedList[index].isRefined = false
          } else {
            refineItem.classList.add('refined')
            refinedList[index].isRefined = true
          }
          buildCurrentRefine()

          setTimeout(() => {
            if (!hasSetupClearEvent && document.querySelector('.ais-ClearRefinements-button')) {
              hasSetupClearEvent = true
              setupClearRefinement()
            }
          }, 200)
        });
      });
      buildCurrentRefine()

      setTimeout(() => {
        if (!hasSetupClearEvent && document.querySelector('.ais-ClearRefinements-button')) {
          setupClearRefinement()
          hasSetupClearEvent = true
        }
      }, 200)
    }
  }

  let renderTimeout = null

  const renderRefinement = connectRefinementList((renderOptions) => {
    if (isUserInteract) {
      return
    }

    clearTimeout(renderTimeout)
    if (!levelRefined[renderOptions.widgetParams.attribute]) {
      levelRefined[renderOptions.widgetParams.attribute] = renderOptions.refine
    }

    renderOptions.items.forEach(item => {
      const index = refinedList.findIndex(sub => sub.value === item.value)
      if (index > -1) {
        refinedList[index].isRefined = item.isRefined
      } else {
        refinedList.push({
          ...item, key: renderOptions.widgetParams.attribute
        })
      }
    })

    if (refinementList[renderOptions.widgetParams.attribute]) {
      const target = refinementList[renderOptions.widgetParams.attribute]
      renderOptions.items.forEach(item => {
        const index = target.items.findIndex(sub => sub.value === item.value)
        if (index > -1) {
          target.items[index].isRefined = item.isRefined
        } else {
          target.items.push({
            ...item, key: renderOptions.widgetParams.attribute
          })
        }
      })
    } else {
      refinementList[renderOptions.widgetParams.attribute] = {
        ...renderOptions
      }
    }

    renderTimeout = setTimeout(() => {
      if (refinedList.length) {
        renderRefineListDOM(renderOptions)
      }

      if (window.cachedRefinement && !hasInitHierarchy) {
        instant.search.setUiState({
          [indexName]: {
            refinementList: window.cachedRefinement
          }
        })
        instant.search.helper.search()
        window.cachedRefinement = null;
      } else {
        hasInitHierarchy = true
        document.querySelector('.ais-facets').classList.remove('ais-loading')
      }
    }, 100)
  })

  instant.search.addWidgets([configure({
    analyticsTags: [getPlatform()], // facets: ['*'],
  }), renderRefinement({
    container: document.querySelector('#hierarchical-level'), operator: 'or', attribute: 'named_tags.lvl0'
  }), renderRefinement({
    container: document.querySelector('#hierarchical-level'), operator: 'or', attribute: 'named_tags.lvl1'
  }), renderRefinement({
    container: document.querySelector('#hierarchical-level'), operator: 'or', attribute: 'named_tags.lvl2'
  }), renderRefinement({
    container: document.querySelector('#hierarchical-level'), operator: 'or', attribute: 'named_tags.lvl3'
  })]);


  instant.search.addWidgets([queryRuleCustomData({
    container: '#queryCollectionBanner', templates: {
      default({items}, {html}) {
        const data = items.filter(item => item.Banners?.id1 === 'top-banner')
        if (data.length) {
          document.querySelector('#queryCollectionBanner').classList.remove('hidden')
        }
        return html`
            ${data.map(item => {
                if (!item.Banners?.image1) {
                    return null
                }

                return `
                <a class="collection-set" href="${item.Banners.Link1}">
                  <img src="${item.Banners.image1.desktop1}" class="desktop"></img>
                  <img src="${item.Banners.image1.mobile1}" class="mobile"></img>
                </a>
            `
            }).join('')}`
      }
    }
  })])

  // instant.search.addWidgets([
  //   customHierarchicalMenu({
  //     container: document.querySelector('#hierarchical-menu'),
  //     attributes: [
  //       'named_tags.lvl0',
  //       'named_tags.lvl1',
  //       'named_tags.lvl2',
  //       'named_tags.lvl3'
  //
  //     ],
  //     limit: 100,
  //     showMoreLimit: 50,
  //     showParentLevel: true,
  //     sortBy: ['name:asc']
  //   })
  // ]);


  // relevant sort
// Create the render function
  const renderSortBy = (renderOptions, isFirstRender) => {
    const {
      options, currentRefinement, refine, widgetParams, // `canRefine` is only available from v4.45.0
      // Use `hasNoResults` in earlier minor versions.
      canRefine,
    } = renderOptions;

    if (isFirstRender) {
      const customSelect = document.createElement('div');
      customSelect.classList.add('ais-custom-select');
      customSelect.style.position = 'relative';

      const selectedDisplay = document.createElement('div');
      selectedDisplay.classList.add('ais-custom-select__selected');

      // Create native hidden select for mobile browser support
      const nativeSelect = document.createElement('select');
      nativeSelect.classList.add('ais-custom-select__native');
      nativeSelect.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
        z-index: 10;
      `;

      // Listen to native select change
      nativeSelect.addEventListener('change', (e) => {
        const value = e.target.value;
        refine(value);

        // Emit change event with value
        const changeEvent = new CustomEvent('change', {
          detail: { value: value },
          bubbles: true
        });
        customSelect.dispatchEvent(changeEvent);
      });

      customSelect.appendChild(nativeSelect);
      customSelect.appendChild(selectedDisplay);

      widgetParams.container.appendChild(customSelect);
    }

    const customSelect = widgetParams.container.querySelector('.ais-custom-select');
    const selectedDisplay = customSelect.querySelector('.ais-custom-select__selected');
    const nativeSelect = customSelect.querySelector('.ais-custom-select__native');

    if (!canRefine) {
      customSelect.classList.add('disabled');
      nativeSelect.disabled = true;
    } else {
      customSelect.classList.remove('disabled');
      nativeSelect.disabled = false;
    }

    // Find current selected option label
    const currentOption = options.find(opt => opt.value === currentRefinement);
    selectedDisplay.innerHTML = `
      <span class="ais-custom-select__text">${currentOption ? currentOption.label : 'Sort By'}</span>
      <svg class="ais-custom-select__icon" xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"></path></svg>
    `;

    // Update native select options (skip first "Sort By" option)
    nativeSelect.innerHTML = options
      .slice(1)
      .map(option => `
        <option value="${option.value}"${option.value === currentRefinement ? ' selected' : ''}>
          ${option.label}
        </option>
      `)
      .join('');
  };

// Create the custom widget
  const customSortBy = connectSortBy(renderSortBy);

// Instantiate the custom widget
  instant.search.addWidgets([// infiniteScroll({
    //   container: document.querySelector('.ais-load-more')
    // }),
    customSortBy({
      container: document.querySelector('.ais-sort'),
      items: [{label: 'Sort By', value: `${algoliaShopify.config.index_prefix}_products`}, {
        label: 'New Arrivals',
        value: 'New Arrivals'
      }, {label: 'Trending', value: 'Trending'}, {
        label: 'Price - High to Low',
        value: 'Price - High to Low'
      }, {label: 'Price - Low to High', value: 'Price - Low to High'},],
    })]);

  window.algoliaInstant = instant

// Get a reference to the select dropdown element


  // Create a render function
  const isRelevantSortedRef = {current: undefined}

  const renderRelevantSort = (renderOptions, isFirstRender) => {
    const {
      isVirtualReplica, isRelevantSorted, refine, widgetParams,
    } = renderOptions;
    isRelevantSortedRef.current = isRelevantSorted;

    if (isFirstRender) {
      const button = document.createElement('button');

      button.addEventListener('click', () => {
        refine(isRelevantSortedRef.current ? 0 : "Price - High to Low");
      });

      widgetParams.container.appendChild(button);
    }

    const button = widgetParams.container.querySelector('button');
    button.textContent = isRelevantSortedRef.current ? 'See all results' : 'See relevant results';
  };

// create custom widget
  const customRelevantSort = connectRelevantSort(renderRelevantSort);

// instantiate custom widget
// instant.search.addWidgets([
//   customRelevantSort({
//     container: document.querySelector('#relevant-sort'),

//   })
// ]);
  // Mobile facets display
  instant.search.addWidgets([{
    init: function () {
      var $button = document.querySelector('.ais-facets-button');
      $button.addEventListener('click', function () {
        var $facets = document.querySelector('.ais-facets');

        if ($facets.classList.contains('ais-facets__shown')) {
          //$button.textContent = 'Refine';
          $facets.classList.remove('ais-facets__shown');

        } else {
          // $button.textContent = 'Refine';
          $facets.classList.add('ais-facets__shown');
          $('html').addClass('hide_scroll');
        }
      });
      var $button2 = document.querySelector('.close_filter_algolia');
      $button2.addEventListener('click', function () {
        var $facets = document.querySelector('.ais-facets');

        if ($facets.classList.contains('ais-facets__shown')) {
          //$button.textContent = 'Refine';
          $facets.classList.remove('ais-facets__shown');
          $('html').removeClass('hide_scroll');
        } else {
          // $button.textContent = 'Refine';
          $facets.classList.add('ais-facets__shown');
        }
      });
      var $button3 = document.querySelector('.see-results-button');
      $button3.addEventListener('click', function () {
        var $facets = document.querySelector('.ais-facets');

        if ($facets.classList.contains('ais-facets__shown')) {
          //$button.textContent = 'Refine';
          $facets.classList.remove('ais-facets__shown');
          $('html').removeClass('hide_scroll');
        } else {
          // $button.textContent = 'Refine';
          $facets.classList.add('ais-facets__shown');
        }
      });


    },
  },]);

  instant.search.addWidgets([configure({
    hitsPerPage: 12, facetingAfterDistinct: Boolean(algolia.config.show_products), // change to false as per Algolia email
    // facetingAfterDistinct: true,
  }),]);
  // Search input
  instant.search.addWidgets([searchBox({
    container: '.ais-search-box-container', // placeholder: algolia.translations.searchForProduct,
    placeholder: 'Search', showReset: false, showSubmit: false,
  }),]);
  //adding query to the search title
  instant.search.addWidgets([{
    init: function () {
      const searchInput = document.querySelector('#template-search .ais-h2.collection_title_algolia');
      const currentURL = window.location.href;
      const urlSearchParams = new URLSearchParams(currentURL);
      const searchQuery = urlSearchParams.get('q');
      if (searchInput) searchInput.innerHTML = `<div>${algolia.translations.searchTitle}` + ` "${searchQuery}"` + `</div>`;

    },
  }]);

  // Logo & clear
  instant.search.addWidgets([{
    init: function (opts) {
      document
        .querySelector('.ais-clear-input-icon')
        .addEventListener('click', function () {
          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });

    }, render: function (opts) {
      if (!opts.state.query) {
        document.querySelector('.ais-clear-input-icon').style.display = 'none';
      } else {
        document.querySelector('.ais-clear-input-icon').style.display = '';
      }
    },
  },]);


  // Sort orders
  // if (activeSortOrders.length > 1) {
  //   instant.search.addWidgets([
  //     sortBy({
  //       container: '.ais-sort-orders-container',
  //       items: instant.sortOrders,
  //     }),
  //   ]);

  // }

  // Change display
  instant.search.addWidgets([{
    init: function () {
      function updateMinHeight() {
        const sourceElement = document.querySelector('.ais-hit--picture');
        const targetElement = document.querySelector('.product-grid__promotion .product-wrap');

        if (sourceElement && targetElement) {
          var sourceHeight = sourceElement.clientHeight;
          targetElement.style.minHeight = `${sourceHeight}px`;
        }
      }


      document
        .querySelector('.ais-search-header .ais-change-display-block')
        .addEventListener('click', function () {

          document
            .querySelector('.ais-change-display-block:not(.ais-change-display-selected)')
            .classList.add('ais-change-display-selected');
          document
            .querySelector('.ais-change-display-list.ais-change-display-selected')
            .classList.remove('ais-change-display-selected');
          document
            .querySelector('.ais-results-as-list')
            .classList.replace('ais-results-as-list', 'ais-results-as-block');
          updateMinHeight();
        });
      document
        .querySelector('.ais-search-header .ais-change-display-list')
        .addEventListener('click', function () {

          document
            .querySelector('.ais-change-display-list:not(.ais-change-display-selected)')
            .classList.add('ais-change-display-selected');
          document
            .querySelector('.ais-change-display-block.ais-change-display-selected')
            .classList.remove('ais-change-display-selected');
          document
            .querySelector('.ais-results-as-block')
            .classList.replace('ais-results-as-block', 'ais-results-as-list');
          updateMinHeight();
        });
    },
  },]);

  // Hidden facets
  var list = instant.facets.hidden.map(function (facet) {
    return facet.name;
  });
  instant.search.addWidgets([{
    // getConfiguration: function () {
    //   return {
    //     facets: list,
    //     disjunctiveFacets: list,
    //   };
    // },
    init: function () {
    },
  },]);

  // Create the render function
  var createDataAttributes = function (refinement) {
    return Object.keys(refinement)
      .map(function (key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItem = function (item) {
    var facet = instant.facets.list.find(function (f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function (refinement) {
        return ('<li class="ais-current-refined-values--item">' + '  <a ' + createDataAttributes(refinement) + '    class="ais-current-refined-values--link">' + '    <div>' + '      <div class="ais-current-refined-values--label">' + facet.title + '      </div>: ' + refinement.label + '    </div>' + '  </a>' + '</li>');
      })
      .join('');
  };

  var renderCurrentRefinements = function (renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;

    widgetParams.container.innerHTML = '<div class="ais-current-refined-values--header ais-facet--header ais-header">Selected filters</div>' + '<div class="ais-root ais-current-refined-values ais-facet">' + '  <ul class="ais-current-refined-values--list">' + items.map(renderListItem).join('') + '  </ul>' + '</div>';

    Array.prototype.slice
      .call(widgetParams.container.querySelectorAll('.ais-current-refined-values--link'))
      .forEach(function (element) {
        element.addEventListener('click', function (event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function (acc, key) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
            return algolia.assign({}, acc, itemData);
          }, {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(renderCurrentRefinements);

  var hasRefinements = function (helper, facetsList) {
    return facetsList.some(function (f) {
      var isConjunctiveFacetRefined = helper.state.isConjunctiveFacet(f.name) && helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined = helper.state.isDisjunctiveFacet(f.name) && helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined = helper.state.isHierarchicalFacet(f.name) && helper.state.isHierarchicalFacetRefined(f.name);

      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function (operator) {
        return numericRefinements[operator].length > 0;
      });

      return (isNumericFacetRefined || isConjunctiveFacetRefined || isDisjunctiveFacetRefined || isHierarchicalFacetRefined);
    });
  };

  /**
   * Decides whether the given `facetName` has any facet values available in
   * the current result set by checking the available `facets`,
   * `disjunctiveFacets` and `hierarchicalFacets`.
   */
  var hasFacetValues = function (resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function (facet) {
      return facet.name === facetName;
    });
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(function (facet) {
      return facet.name === facetName;
    });
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(function (facet) {
      return facet.name === facetName;
    });

    return (isFacetValueAvailable || isDisjunctiveFacetValueAvailable || isHierarchicalFacetValueAvailable);
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function (options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var customCurrentRefinementsCategoriesWithPanel = panel({
    hidden: function (options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinementsCategories);


  var clearRefinementsWithPanel = panel({
    hidden: function (options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(clearRefinements);

  instant.search.addWidgets([clearRefinementsWithPanel({
    container: document.querySelector('.ais-clear-refinements-container'), templates: {
      resetLabel: algolia.translations.clearAll,
    },
  }), customCurrentRefinementsWithPanel({
    container: document.querySelector('.ais-current-refined-values-container'),
  }), customCurrentRefinementsCategoriesWithPanel({
    container: document.querySelector('.ais-current-refined-values-container_categories'),
  }),]);

  /**
   * Setup the facets for search.
   * We are using a `panel` with a custom `hidden` function which will allow
   * us to hide the parent container of the facet if there are no facet values
   * available for that particular facet.
   */
  instant.facets.widgets.forEach(function (widget) {
    var facetWithPanel = panel({
      hidden: function (options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute);
        var displayStyle = hide ? 'none' : '';

        /**
         * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
         * can work as expected. "." is supposed to be present for named tags
         * and metafield based facet names and "%" is present when the facet name has a space
         * in it because of the encoding.
         */
        var parentContainerClassName = '.ais-facet-' + encodeURIComponent(widget.params.attribute).replace(/\./g, '\\.').replace(/\%/g, '\\%');
        var parentContainer = document.querySelector(parentContainerClassName);

        if (parentContainer) {
          parentContainer.style.display = displayStyle;
        }

        return hide;
      },
    })(widget.widget);

    instant.search.addWidgets([facetWithPanel({
      ...widget.params,
    })]);
  });

  const videoMap = {}
  let scrollTimeOut = null

  function setupBackScroll() {
    if (sessionStorage.getItem('plp-object-id')) {
      let objectId = sessionStorage.getItem('plp-object-id')
      const observer = new MutationObserver((mutations) => {
        if (mutations.find(item => item.target.closest('.plp-cols')?.getAttribute(`data-algolia-objectid`) === objectId)) {
          if (scrollTimeOut) {
            clearTimeout(scrollTimeOut)
          }
          scrollTimeOut = setTimeout(() => {
            if (document.querySelector(`[data-algolia-objectid="${objectId}"]`)) {
              document.querySelector(`[data-algolia-objectid="${objectId}"]`)
                .closest('.ais-InfiniteHits-item')
                .scrollIntoView({behavior: "smooth", block: "center"});
            }
            observer.disconnect()
          }, 150)
        }
      })

      observer.observe(document.querySelector('.ais-hits-container'), {
        childList: true, subtree: true
      })
      sessionStorage.removeItem('plp-object-id')
    }
  }

  instant.search.addWidgets([hits({
    showPrevious: true,
    container: '.ais-hits-container', // cache: instantsearch.createInfiniteHitsSessionStorageCache(),
    templates: {
      item(hit, data) {
        const {html, components} = data

        let queryID = localStorage.getItem("queryID");

        if (queryID != hit.queryID) {
          localStorage.setItem("queryID", hit.queryID);
        }

        var slider_recommned = document.querySelector('#shopify-section-recommended-products__collection-page')
        if (slider_recommned) slider_recommned.style.display = "block";
        const getConversionData = (e, hit) => {
          if (!algolia.config.analytics_enabled) return;
          var clickData = {}
          if (algolia.is_collection_results_page) {
            // clickData = {
            //   index: hit.index,
            //   eventName: 'Added to cart (PLP)',
            //   queryID: hit.queryID,
            //   objectIDs: [hit.objectID],
            // };
            clickData = {
              eventType: "conversion",
              eventSubtype: "addToCart",
              index: hit.index,
              eventName: 'Added to cart (PLP)',
              objectIDs: [hit.objectID],
              objectData: [{
                queryID: hit.queryID, // optional
                price: hit.price, // required (the sale price is the per item list price minus discount)
                discount: hit.compare_at_price > 0 ? hit.compare_at_price - hit.price : 0, quantity: 1,
              }],
              value: hit.price,
              currency: "AUD" // required
            };
          } else {
            // clickData = {
            //   index: hit.index,
            //   eventName: 'Added to cart (Search)',
            //   queryID: hit.queryID,
            //   objectIDs: [hit.objectID],
            // };
            clickData = {
              eventType: "conversion",
              eventSubtype: "addToCart",
              index: hit.index,
              eventName: 'Added to cart (Search)',
              objectIDs: [hit.objectID],
              objectData: [{
                queryID: hit.queryID, // optional
                price: hit.price, // required (the sale price is the per item list price minus discount)
                discount: hit.compare_at_price > 0 ? hit.compare_at_price - hit.price : 0, quantity: 1
              }],
              value: hit.price,
              currency: "AUD" // required
            };
          }

          /**
           * Uncomment the following function call to start storing data in
           * local storage for conversion tracking
           */
          algolia.saveForConversionTracking(clickData);
        }

        if (hit.tags) {
          const videoTag = hit.tags.find(item => item === 'algolia-video-enabled')
          const mapIndex = Math.floor((hit.videoIndex) / 8)

          if (!videoMap[mapIndex] && videoTag) {
            videoMap[mapIndex] = videoTag
            return algolia.instantSearchProductTemplate(hit, html, components, getConversionData, videoTag);
          }
        }

        return algolia.instantSearchProductTemplate(hit, html, components, getConversionData, '');
      }, empty(results, {html}) {
        return algolia.instantSearchNoResultTemplate(html);
      }
    },
    transformItems: function (items, {results}) {
      setupBackScroll()
      // Check if promo banner is enabled
      const isPromoBannerEnabled = theme.grid_banner.enable;

      const promoBanner = isPromoBannerEnabled ? {
        objectID: 'promo_banner',
      } : null;


      // Add the promo banner as the third hit in the items array
      const itemsWithPromoBanner = isPromoBannerEnabled ? [...items.slice(0, 3), promoBanner, ...items.slice(3)] : items;

      // Remove the last item if the promo banner is present
      const itemsWithoutLastProduct = isPromoBannerEnabled && promoBanner ? itemsWithPromoBanner.slice(0, -1) : itemsWithPromoBanner;

      const gridBanner = results.userData?.find(item => item?.Banners?.id2 === 'productgridbanner') ?? null
      if (gridBanner && results.page === 0) {
        itemsWithoutLastProduct.splice(7, 0, {
          objectID: 'promo_banner', Link: gridBanner.Banners.Link2, gridBannerUrl: gridBanner.Banners.image2.desktop2,
        })
      }

      // Filter out items that have the "algolia30days" tag
      const filteredItems = itemsWithoutLastProduct.filter(item => {
        // Check if the item's tags array contains "algolia30days"

        if (item.tags) {
          return !item.tags.includes('algolia30days');
        } else {
          return true
        }

      });
      // instant.search.mainIndex.nbHits = filteredItems.length;
      // Modify the existing items using map and return the result
      return filteredItems.map((item, index) => ({
        ...item,
        _distinct: instant.distinct,
        page: results.page + 1,
        videoIndex: results.page * results.hitsPerPage + index,
        can_order: item.inventory_management !== 'shopify' || item.inventory_policy === 'continue',
        queryID: item.__queryID,
        __hit_position: index,
        index: instant.search.mainIndex.getIndexName(),
        distinct: true
      }));
    }
  })]);

  // Stats
  instant.search.addWidgets([stats({
    container: '.ais-stats-container', templates: {
      text(data, {html}) {
        return algolia.instantSearchStatsTemplate(data, html)
      }
    }
  }),]);


  // Redirect to product on click
  instant.search.addWidgets([{
    init: function () {
      var container = document.querySelector('.ais-hits-container');
      container.addEventListener('click', function (e) {
        var el = e.target;
        var hit;
        do {
          if (el.matches('.ais-hit')) {
            hit = el;
            break;
          }
          el = el.parentNode;
        } while (el && el !== container);
        if (!hit) {
          return;
        }
        var $this = hit;
        var productHandle = $this.dataset.handle;
        var variant_id = $this.dataset.variantId;
        var distinct = $this.dataset.distinct;

        // Construct the link we should redirect to
        var link = '';

        // If we're on a collection page and the handle is available
        // then prefix the product link with the collection handle
        if (collectionPageEnabled && collectionHandle) {
          link = '/collections/' + collectionHandle;
        }

        // Add the product handle to the link
        link = link + '/products/' + productHandle;

        // Add the variant ID details to redirect to a specific
        // variant ID if we are showing variants and not products
        if (distinct !== 'true') {
          link += '?variant=' + variant_id;
        }

        if (algolia.config.analytics_enabled) {
          var clickData = {}
          var clickData_pdp = {}
          if (algolia.is_collection_results_page) {
            clickData = {
              eventType: "view",
              index: hit.dataset.algoliaIndex,
              eventName: 'View Collection',
              queryID: hit.dataset.algoliaQueryid,
              objectIDs: [hit.dataset.algoliaObjectid],
            };
            // clickData_pdp = {
            //   index: hit.dataset.algoliaIndex,
            //   eventName: 'added to cart (PDP - Collection)',
            //   queryID: hit.dataset.algoliaQueryid,
            //   objectIDs: [hit.dataset.algoliaObjectid],
            // };
            clickData_pdp = {
              eventType: "conversion",
              eventSubtype: "purchase",
              index: hit.dataset.algoliaIndex,
              eventName: 'Add cart (PDP - Collection)',
              objectIDs: [hit.dataset.algoliaObjectid],
              objectData: [{
                // revenue data for 'black-t-shirt-xxl'
                queryID: hit.dataset.algoliaQueryid, // optional
                price: hit.dataset.price, // required (the sale price is the per item list price minus discount)
                discount: hit.dataset.discount, quantity: 1,
              }],
              value: hit.dataset.price,
              currency: "AUD" // required
            };
          } else {
            clickData = {
              eventType: "view",
              index: hit.dataset.algoliaIndex,
              eventName: 'View Search',
              queryID: hit.dataset.algoliaQueryid,
              objectIDs: [hit.dataset.algoliaObjectid],
            };
            clickData_pdp = {
              eventType: "conversion",
              eventSubtype: "addToCart",
              index: hit.dataset.algoliaIndex,
              eventName: 'Added to cart (PDP - Search)',
              objectIDs: [hit.dataset.algoliaObjectid],
              objectData: [{
                // revenue data for 'black-t-shirt-xxl'
                queryID: hit.dataset.algoliaQueryid, // optional
                price: hit.dataset.price, // required (the sale price is the per item list price minus discount)
                discount: hit.dataset.discount, quantity: 1,
              }],
              value: hit.dataset.price,
              currency: "AUD" // required
            };


          }


          //aa.clickedObjectIDsAfterSearch(clickData);
          /**
           * Uncomment the following function call to start storing data in
           * local storage for conversion tracking
           */
          algolia.saveForConversionTracking(clickData);
          //const data_algolia = JSON.parse(clickData);
          const localStorageKey_pdp = 'localStorageKey_pdp';
          localStorage.setItem(localStorageKey_pdp, JSON.stringify(clickData_pdp))
        }
        // window.location.href = link;
      });
    },
  },]);

  // Add to cart
  instant.search.addWidgets([{
    init: function () {
      // var container = document.querySelector('.ais-hits-container');
      // container.addEventListener('click', function (e) {
      //   var el = e.target;
      //   var cartButton;
      //   do {
      //     if (el.matches('.ais-hit--cart-button')) {
      //       cartButton = el;
      //       break;
      //     }
      //     el = el.parentNode;
      //   } while (el && el !== container);
      //   if (!cartButton) {
      //     return;
      //   }
      //
      //   e.stopPropagation();
      //   var $this = cartButton;
      //   var formId = $this.dataset.formId;
      //
      //   if (formId) {
      //     document.getElementById(formId).submit();
      //   }
      // });
    },
  },]);

  // No result actions
  instant.search.addWidgets([{
    init: function (opts) {
      var container = document.querySelector('.ais-hits-container');
      container.addEventListener('click', function (e) {
        var el = e.target;
        var clearFilters;
        do {
          if (el.matches('.ais-hit-empty--clear-filters')) {
            clearFilters = el;
            break;
          }
          el = el.parentNode;
        } while (el && el !== container);
        if (!clearFilters) {
          return;
        }

        var helper = opts.helper;
        helper.clearTags();
        instant.facets.list.forEach(function (facet) {
          helper.clearRefinements(facet.name);
        });
        helper.search();
      });

      container.addEventListener('click', function (e) {
        var el = e.target;
        var clearInput;
        do {
          if (el.matches('.ais-hit-empty--clear-input')) {
            clearInput = el;
            break;
          }
          el = el.parentNode;
        } while (el && el !== container);
        if (!clearInput) {
          return;
        }

        opts.helper.setQuery('').search();
        var input = document.querySelector('.ais-search-box--input');
        input.value = '';
        input.focus();
      });
    },
  },]);

  // Pagination
  // instant.search.addWidgets([
  //   pagination({
  //     container: '.ais-pagination-container',
  //     padding: 2,
  //     maxPages: 20,
  //   }),
  // ]);
  // duplicate breadcrumbs
  var sourceDiv = document.querySelector('.breadcrumb__container');
  if (sourceDiv) {


    var clonedDiv = sourceDiv.cloneNode(true); // Cloning the source div

    replaceH6WithH1(clonedDiv);

    var targetDiv = document.querySelector('.algolia_breadcrumbs');
    targetDiv.appendChild(clonedDiv);

  }

  function replaceH6WithH1(element) {
    // Get all h6 elements inside the element
    var h6Elements = element.querySelectorAll('h6');

    // Iterate over each h6 element
    h6Elements.forEach(function (h6Element) {
      // Create a new h1 element
      var h1Element = document.createElement('h1');
      h1Element.classList.add('collection_title_algolia');
      // Copy the content of the h6 element to the new h1 element
      h1Element.innerHTML = h6Element.innerHTML;

      // Replace the h6 element with the new h1 element
      h6Element.parentNode.replaceChild(h1Element, h6Element);
    });
  }

  instant.search.start();

  // after all elements have been loaded
  instant.search.on('render', () => {
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    if (window._swat) {

      window._swat.initializeActionButtons(".ais-hits-container");
    } else {

      window.SwymCallbacks = window.SwymCallbacks || [];

      window.SwymCallbacks.push(function () {
        window._swat.initializeActionButtons(".ais-hits-container");
      });
    }
    const searchInput = document.querySelector('#template-search .ais-h2.collection_title_algolia');

    function isParameterInURL(parameterName) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      return urlParams.get(parameterName);
    }

    if (searchInput) searchInput.innerHTML = `<div>${algolia.translations.searchTitle + " " + `"` + isParameterInURL('q')}"</div>`;

    // var selectElement = document.querySelector(".ais-SortBy-select");
    // if (selectElement){
    //   var placeholderOption = selectElement.querySelector(`option[value="${algoliaShopify.config.index_prefix}products"]`);
    //
    //   if (placeholderOption) {
    //     // Placeholder option already exists, update its value and text
    //     debugger
    //     placeholderOption.value = `${algoliaShopify.config.index_prefix}products`;
    //     placeholderOption.text = "Sort By";
    //   } else {
    //     debugger
    //     // Placeholder option doesn't exist, create a new one
    //     var newOption = document.createElement("option");
    //     newOption.value = `${algoliaShopify.config.index_prefix}products`;
    //     newOption.text = "Sort By";
    //     // Insert the new option as the first option
    //     selectElement.insertBefore(newOption, selectElement.firstChild);
    //   }
    // }
    // Set the placeholder text
    const searchBar = document.getElementById("autocomplete-0-input");
    if (searchBar) {
      if (searchBar && !searchBar.hasAttribute("aria-controls")) {
        searchBar.placeholder = "Search";
      }
      const initialPlaceholder = searchBar.placeholder;
      searchBar.addEventListener("input", function () {
        // If the input field is empty, restore the initial placeholder text
        if (!searchBar.hasAttribute("aria-controls")) {
          searchBar.placeholder = initialPlaceholder;
        } else {
          // If the input field has text, clear the placeholder
          searchBar.placeholder = "test";
        }
      });
    }


    // Get the <ul> element by its ID
    const myList = document.querySelector('.ais-current-refined-values--list');
    if (myList) {
      // Get all <li> elements inside the <ul>
      const liItems = myList.querySelectorAll('li');
      // Get the number of <li> items
      const numberOfItems = liItems.length;
      if (numberOfItems > 0) {
        const quantityDiv = document.getElementById('filter_quantity');
        quantityDiv.innerText = `(${numberOfItems})`;
      } else {
        const quantityDiv = document.getElementById('filter_quantity');
        quantityDiv.innerText = ``;

      }
    }
    // JavaScript code for the sort by width
    const sortBySelect = document.querySelector(".ais-SortBy-select");

    function adjustSelectWidth() {
      if (sortBySelect) {


        const selectedOption = sortBySelect.options[sortBySelect.selectedIndex];
        const selectedOptionText = selectedOption.textContent;

        // Create a temporary element to measure the width of the option text
        const tempElement = document.createElement('span');
        tempElement.style.visibility = 'hidden';
        tempElement.style.position = 'absolute';
        tempElement.textContent = selectedOptionText;
        document.body.appendChild(tempElement);

        // Set the width of the select to match the width of the option text
        sortBySelect.style.width = `${tempElement.clientWidth + 28}px`; // Add some padding

        // Remove the temporary element
        document.body.removeChild(tempElement);
      }
    }

    // Add event listener to adjust the width when the selection changes
    if (sortBySelect) {
      sortBySelect.addEventListener('change', adjustSelectWidth);
    }


    // Set the initial width when the page loads
    adjustSelectWidth();

    const fixedDiv = document.querySelector('.algolia_header');
    const targetDiv = document.querySelector('.mobile-header');
    const filters_parent_mobile = document.querySelector('.algolia_breadcrumbs');

    var targetDivHeight = 0;
    var isSticky = false;
    var prevScrollY = 0;

    if (targetDiv) {
      targetDivHeight = targetDiv.offsetHeight;
    }

    function isFullyVisible(element) {
      const rect = element.getBoundingClientRect();
      return (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight));
    }

    function updateFixedState() {
      const filtersMobileRect = filters_parent_mobile.getBoundingClientRect();
      const currentScrollY = window.scrollY || window.pageYOffset;
      if (currentScrollY > prevScrollY) {
        // Scrolling down
        if (filtersMobileRect.top <= targetDivHeight && !isSticky) {

          // If the filters_mobile div is below the targetDiv and not already sticky, make it sticky below the targetDiv
          fixedDiv.classList.add('sticky-enabled');
          fixedDiv.style.top = '0';
          isSticky = true;
        } else if (filtersMobileRect.top > targetDivHeight && isSticky) {

          // If the filters_mobile div is above the targetDiv and the div is sticky, remove sticky behavior
          fixedDiv.classList.remove('sticky-enabled');
          fixedDiv.style.top = '';
          isSticky = false;
        } else if (filtersMobileRect.top <= targetDivHeight && isSticky) {
          fixedDiv.style.top = '0';
        }

      } else {
        if (currentScrollY === 0 && isSticky) {

          // If at the top of the page and the div is sticky, make it sticky at the top
          fixedDiv.classList.add('sticky-enabled');
          fixedDiv.style.top = '0';
        } else if (filtersMobileRect.top <= targetDivHeight && isSticky) {

          // If the filters_mobile div is below or at the level of the targetDiv and the div is not sticky, make it sticky below the targetDiv
          fixedDiv.classList.add('sticky-enabled');
          fixedDiv.style.top = targetDivHeight - 2 + 'px';
          isSticky = true;
        } else if (isSticky && filtersMobileRect.top > targetDivHeight) {

          // If the filters_mobile div is above the targetDiv and the div is sticky, remove sticky behavior
          fixedDiv.classList.remove('sticky-enabled');
          fixedDiv.style.top = '';
          isSticky = false;
        }
      }

      // Update the previous scroll position
      prevScrollY = currentScrollY;
    }

    // Listen for the scroll event and update the fixed state
    window.addEventListener('scroll', updateFixedState);

    // Initial update to set the fixed state on page load (in case the div is already off the viewport)
    updateFixedState();

    const ulElement = document.querySelector('#hierarchical-menu .ais-RefinementList-list');
    var hide_categories = document.querySelector(".ais-facet-dropdown-wrapper.ais-facet-categories.ais-facet-categories");
    // Check if it's empty
    if (ulElement?.childElementCount === 0) {
      // Hide the <ul> element
      ulElement.style.display = 'none';
      hide_categories.style.display = "none";
    } else if (ulElement) {
      ulElement.style.display = 'block';
      hide_categories.style.display = "block";
    }

    const ulElement_selected_categ = document.querySelector('.categories_selected ul.ais-current-refined-values--list');
    var hide_categories_refinement = document.querySelector(".ais-current-refined-values-container_categories");
    // Check if it's empty

    if (ulElement_selected_categ) {
      if (ulElement_selected_categ.childElementCount === 0) {
        // Hide the <ul> element
        hide_categories_refinement.classList.add('hidden');
      } else {
        hide_categories_refinement.classList.remove('hidden');
      }
    }
    var overlay = document.querySelector('#overlay_algolia');
    var filter_container = document.querySelector(".ais-facets.test")
    var dom_html = document.querySelector('html')
    overlay.addEventListener('click', () => {
      filter_container.classList.remove('ais-facets__shown');
      dom_html.classList.remove('hide_scroll')
    });


  });

  instant.search.on('error', () => {
    document.querySelector('.ais-InfiniteHits-loadMore')?.click()
  })

  algolia.contentHide.parentNode.removeChild(algolia.contentHide);
})(window.algoliaShopify);

